import { createApiSlice } from 'app/createApiSlice'

export const settingApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'settings',
  endpoints(builder) {
    return {
      fetchSettings: builder.query({
        query() {
          return `/api/v1/bussines/profile`
        },
      }),
      fetchTeamList: builder.query({
        query(payload) {
          let url = `/api/v1/bussines/team`

          return {
            url,
            params: {
              page: payload.page ?? 0,
              size: payload.size ?? 10,
              sortby: payload.sortby,
              sortdir: payload.sortdir,
              s: payload.search,
            },
          }
        },
      }),
      uploadImagePublic: builder.mutation({
        query(img) {
          const image = new FormData()
          image.append('file', img)
          return {
            url: `/api/v1/upload/publicfile`,
            method: 'POST',
            body: image,
          }
        },
      }),
      updateAvatarUser: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/profile`,
            method: 'PATCH',
            body: payload,
          }
        },
      }),
      getUserAvatar: builder.query({
        query(userIds) {
          return {
            url: `/api/v1/bussines/profilepics`,
            method: 'POST',
            body: {
              userIds: [...userIds],
            },
          }
        },
      }),
      changePin: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/changepin`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      getAutoNumberConfigs: builder.query({
        query() {
          return `/api/v1/bussines/autonumber`
        },
      }),
      saveAutoNumberConfig: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/autonumber`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      previewAutoNumberConfig: builder.query({
        query({ type, pattern }) {
          return {
            url: `/api/v1/bussines/autonumber/preview?type=${type}&pattern=${pattern}`,
          }
        },
      }),
      updateCompanyLogo: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/logo`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      updateCompanyInfo: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/update`,
            method: 'POST',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchSettingsQuery,
  useFetchTeamListQuery,
  useUploadImagePublicMutation,
  useGetUserAvatarQuery,
  useUpdateAvatarUserMutation,
  useChangePinMutation,
  useGetAutoNumberConfigsQuery,
  useSaveAutoNumberConfigMutation,
  usePreviewAutoNumberConfigQuery,
  useLazyPreviewAutoNumberConfigQuery,
  useUpdateCompanyLogoMutation,
  useUpdateCompanyInfoMutation,
} = settingApiSlice
